import { Injectable } from '@angular/core';
import { Proforma, LineaProforma } from '@arpada/arp-lib-common-qupro';
import { ProformaFront, ProformaStateFront, ProformaLineasProformaFront, IssueStateGroupFront } from '../../models/front-dto/api.dto';

@Injectable({
  providedIn: 'root'
})
export class ProformaPopulateService {

  constructor() { }

  public convertirProformasToProformasFront(proformas: Proforma[]): ProformaFront[]{
    const proformasFront: ProformaFront[] = [];
    proformas.forEach(proforma => {
      const proformaFront = new ProformaFront();
      proformaFront.id = proforma.id;
      proformaFront.csite_name = proforma.csite_name;
      proformaFront.proformaState = new ProformaStateFront();
      proformaFront.proformaState.state = proforma.state_name;
      proformaFront.proformaState.stateKey = proforma.state_key;
      proformaFront.date = proforma.date;
      proformaFront.amount = proforma.amount;
      proformaFront.line_ids = proforma.line_ids;
      proformaFront.supplier_actions = proforma.supplier_actions;
      proformaFront.rejection_reason = proforma.rejection_reason;
      proformasFront.push(proformaFront);
      // proformasFront = [...this.proformasFront]; // refresh data si no no pinta los datos parseados
    });
    return proformasFront;
  }

  public convertirProformasFrontToProformas(proformasFront: ProformaFront[]): Proforma[] {
    const proformas: Proforma[] = [];
    proformasFront.forEach((proformaFront: ProformaFront) => {
      const proforma = new Proforma();
      proforma.id = proformaFront.id;
      proforma.csite_name = proformaFront.csite_name;
      proforma.state_name = proformaFront.proformaState.state;
      proforma.state_key = proformaFront.proformaState.stateKey;
      proforma.date = proformaFront.date;
      proforma.amount = proformaFront.amount;
      proforma.line_ids = proformaFront.line_ids;
      proforma.supplier_actions = proformaFront.supplier_actions;
      proforma.rejection_reason = proformaFront.rejection_reason;
      proformas.push(proforma);
    });
    return proformas;
  }

  public convertirProformaToProformaFront(proforma: Proforma): ProformaFront {
    const proformaFront = new ProformaFront();
    proformaFront.id = proforma.id;
    proformaFront.csite_name = proforma.csite_name;
    proformaFront.proformaState = new ProformaStateFront();
    proformaFront.proformaState.state = proforma.state_name;
    proformaFront.proformaState.stateKey = proforma.state_key;
    proformaFront.date = proforma.date;
    proformaFront.amount = proforma.amount;
    proformaFront.line_ids = proforma.line_ids;
    proformaFront.supplier_actions = proforma.supplier_actions;
    proformaFront.rejection_reason = proforma.rejection_reason;
    return proformaFront;
  }

  public convertirLineasProformaToProformaLineasProformaFront(lProformas: LineaProforma[]): ProformaLineasProformaFront[] {
    const pLineasProformaFront: ProformaLineasProformaFront[] = [];
    lProformas.forEach(linea => {
      const row = new ProformaLineasProformaFront();
      row.lineId = linea.line_id;
      row. issueId = linea.issue_id;
      row.vivienda = `Portal: ${linea.portal} Piso: ${linea.floor} Letra: ${linea.letter}`;
      row.issueStateGroup = new IssueStateGroupFront();
      row.issueStateGroup.stateGroup = linea.state_group_name;
      row.issueStateGroup.stateGroupKey = linea.state_group_key;

      row.descripcion = linea.name;
      row.localizacion = linea.location_name;
      row.conforme = linea.has_agreement;
      row.manoObra = linea.labor_cost;
      row.material = linea.material_cost;
      row.requierePresupuestoAprobado = linea.b_requiere_presupuesto_aprobado;
      pLineasProformaFront.push(row);
      // pLineasProformaFront = [...this.pLineasProformaFront]; // refresh data si no no pinta los datos parseados
    });
    return pLineasProformaFront;
  }
}
